// Dr.Rx™ Primary Navigation Footer
import React from 'react';
import type { View } from '../types';

const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
);
const ChatIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>
);
const LibraryIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
);
const ProfileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
);

interface FooterProps {
  currentView: View;
  onNavigate: (view: View) => void;
}

const Footer: React.FC<FooterProps> = ({ currentView, onNavigate }) => {
  const navItems = [
    { name: 'Home', view: 'dashboard', icon: <HomeIcon /> },
    { name: 'AI Co-Pilot', view: 'chat', icon: <ChatIcon />, badge: 'AI' },
    { name: 'Library', view: 'library', icon: <LibraryIcon /> },
    { name: 'Account', view: 'account', icon: <ProfileIcon /> },
  ];

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-[#101D35]/95 border-t border-blue-900/50 backdrop-blur-xl z-50 pb-[env(safe-area-inset-bottom,0px)] shadow-[0_-8px_30px_rgba(0,0,0,0.4)]">
       <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent"></div>
      <nav className="flex justify-around items-center max-w-4xl mx-auto h-16">
        {navItems.map((item) => {
          const isActive = currentView === item.view;
          return (
            <button
              key={item.name}
              onClick={() => onNavigate(item.view as View)}
              className={`relative flex flex-col items-center justify-center w-full h-full transition-all duration-300 group ${
                isActive ? 'text-yellow-400' : 'text-gray-400 hover:text-white'
              }`}
            >
              {isActive && <span className="absolute top-0 h-0.5 w-12 rounded-full bg-yellow-400 shadow-[0_0_8px_2px_rgba(250,204,21,0.6)]"></span>}
              <div className={`relative p-1 rounded-full transition-transform duration-200 ${isActive ? '-translate-y-1' : 'group-hover:-translate-y-0.5'}`}>
                 {item.icon}
                 {item.badge && (
                   <span className={`absolute -top-1 -right-2.5 text-[8px] font-black px-1 py-0.2 rounded-full border ${
                     isActive ? 'bg-yellow-400 text-slate-950 border-yellow-300' : 'bg-blue-900/90 text-yellow-400 border-yellow-400/40'
                   }`}>
                     {item.badge}
                   </span>
                 )}
              </div>
              <span className={`text-[10px] ${isActive ? 'font-bold text-yellow-400' : 'font-medium'}`}>{item.name}</span>
            </button>
          );
        })}
      </nav>
    </footer>
  );
};

export default Footer;
